<template>
  <div id="HolterJudgmentModal">
    <div
      class="modal-card"
      style="width:900px;">
      <header class="modal-card-head">
        <p
          class="modal-card-title"
          style="color: whitesmoke;">
          {{ title }}
        </p>
      </header>
      <section class="modal-card-body">
        <!--検索条件 -->
        <div class="condition-area">
          <table class="conditionTable">
            <tr>
              <th>{{ labelForOrg }}</th><td><input
                v-model="searchConditions.doctorName"
                type="text"></td>
            </tr>
          </table>
          <div
            class="searchButton-area"
            style="margin-bottom:10px;text-align: center;">
            <b-button
              class="is-primary"
              @click="doSearch">検索</b-button>
          </div>
        </div>
        <!-- 検索結果 -->
        <div class="result-area">
          <b-table
            v-if="data.length > 0"
            id="customerSelectTable"
            :data="data"
            paginated
            per-page="20"
            pagination-position="both"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page"
          >
            <template slot-scope="props">
              <b-table-column
                field="customerId"
                label=""
                width="20"
                centered>
                <b-radio
                  v-model="selectedItem"
                  :native-value="props.row"
                  class="customRadio"
                  name="radioItem"/>
              </b-table-column>
              <b-table-column
                :label="labelForOrg"
                field="doctorName"
                width="300"
                sortable >{{ props.row.doctorName }}</b-table-column>
              <b-table-column
                field="address"
                label="住所"
                width="500"
                sortable >{{ props.row.address }}</b-table-column>
            </template>
          </b-table>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          :disabled="!selectedItem"
          class="button"
          type="button"
          @click="save">決定</button>
        <button
          class="button"
          type="button"
          @click="$parent.close()">閉じる</button>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HolterJudgmentModal',
  filters: {},
  components: {},
  props: {
    title: {
      type: String,
      default: '組織選択'
    },
    labelForOrg: {
      type: String,
      default: '組織名'
    },
    selectRole: {
      type: Array,
      default: () => []
    },
    canSelect: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      data: [],
      searchConditions: {
        doctorName: ''
      },
      selectedRole: '',
      selectedItem: ''
    }
  },
  mounted: function () {},
  methods: {
    save: function () {
      this.$emit('select', this.selectedItem)
      this.$parent.close()
    },
    doSearch: function () {
      const _this = this
      this.selectedItem = ''
      const searchConditions = JSON.parse(JSON.stringify(this.searchConditions))
      // Web Api Call
      this.apiCall(
        function (client) {
          return client.apis.apiCommon.getHolterJudgmentDoctorListPOST({
            body: searchConditions
          })
        },
        function (result) {
          // 検索結果取得
          _this.data = result.obj.map(function (item) {
            return Object.assign({}, item, {
              id: item.doctorId,
              orgName: item.doctorName,
              roleName: item.hospitalName
            })
          })
        },
        function (result) {
          // エラーメッセージ表示
          _this.showErrorMessage(result)
        }
      )
    },

    canSelectRole: function (selectValue) {
      let ret = true
      if (this.selectRole) {
        ret = this.selectRole.indexOf(selectValue) > -1
      }
      return ret
    }
  }
}
</script>
<style lang="scss" scoped>
.customRadio {
  width:10px;
}
.result-area {
  height: 450px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/common/HolterJudgmentModal.vue